import { Badge } from '@esnafai/shared/ui';
import { config } from '@/lib/config';

// The environment badge of the header: VITE_ENV outside production (merchant screens §2; environments §3.4). The
// value is an environment name, shown as it is.
export function EnvBadge() {
  if (config.env === 'production') return null;
  return <Badge tone="warning">{config.env}</Badge>;
}
